import app from '../app'
import moment from 'moment'

class PrivacyPolicyPopup {
    /*@ngInject*/
    constructor($cookies, $timeout) {
        this.$cookies = $cookies
        this.$timeout = $timeout
        this.show = !this.$cookies.get('hasShownPrivacyPolicyPopup')
        if(!this.$cookies.get('hasShownPrivacyPolicyPopup')){
            const width = $('div#hubspot-messages-iframe-container').width();
            const height = $('div#hubspot-messages-iframe-container').height();
            $('#hubspot-messages-iframe-container').css("cssText", "bottom: 100px !important;width: " + width + "px;height: " + height + "px");
        }

    }

    close() {
        this.show = false
        let date = new Date(
            moment(new Date())
                .add(1, 'months')
                .toDate(),
        )
        const width = $('div#hubspot-messages-iframe-container').width();
        const height = $('div#hubspot-messages-iframe-container').height();
        $('#hubspot-messages-iframe-container').css("cssText", "bottom: 0 !important;width: " + width + "px;height: " + height + "px");
        this.$cookies.put('hasShownPrivacyPolicyPopup', true, { expires: date.toGMTString() })
    }
}

app.component('privacyPolicyPopup', {
    template: require('./privacy-policy-popup.component.html'),
    controller: PrivacyPolicyPopup,
    controllerAs: 'vm',
})



// WEBPACK FOOTER //
// ./static/js/app/components/privacy-policy-popup.component.js